'use client';

import { motion } from 'framer-motion';
import { entrance, type FlowLabel as FlowLabelPlace } from '@/src/shared/lib/chart';

interface FlowLabelProps {
  label: FlowLabelPlace;
  name: string;
  amount: string;
  reduced: boolean;
  delay: number;
  /** A card-coloured halo, for a label that sits over the ribbons. */
  halo?: boolean;
}

/** A flow node's name and amount, where the label layout placed them. */
export function FlowLabel({ label, name, amount, reduced, delay, halo = false }: FlowLabelProps) {
  const haloProps = halo
    ? { stroke: 'hsl(var(--card))', strokeWidth: 3, paintOrder: 'stroke' as const }
    : {};
  return (
    <motion.g aria-hidden pointerEvents="none" {...entrance('fade', { reduced, delay })}>
      {label.leader && (
        <line
          {...label.leader}
          stroke="hsl(var(--muted-foreground))"
          strokeOpacity={0.6}
          strokeWidth={1}
        />
      )}
      <g {...haloProps}>
        <text
          x={label.x}
          y={label.nameY}
          textAnchor={label.anchor}
          fontSize={12}
          fontWeight={500}
          className="fill-muted-foreground"
        >
          {name}
        </text>
        <text
          x={label.valueX}
          y={label.valueY}
          textAnchor={label.valueAnchor}
          fontSize={13}
          fontWeight={600}
          className="fill-foreground tabular-nums"
        >
          {amount}
        </text>
      </g>
    </motion.g>
  );
}
